import encodeAndStringify from './encodeAndStringify';
import { AppliedFilters } from '../contracts';

export default function generateUrlWithFilters(
  filters?: Partial<AppliedFilters>
) {
  return filters
    ? `/cars/filters?cvnaid=${encodeAndStringify(filters)}`
    : '/cars';
}
